const PIPE_DELIMITED_COLUMNS = new Set(['whatsNext', 'nextNodes']);

export function getArrayJoinDelimiter(cellId: string): string {
  return PIPE_DELIMITED_COLUMNS.has(cellId) ? '|' : ', ';
}
